module.exports = __webpack_public_path__ + "static/media/logo_casa_do_pequeno_cidadao_branco_e_preto.9e2139a6.png";